// v2.0 #3 — safe date formatting helpers. `new Date(null)` returns 1970,
// which is the source of the "tickets show 1970" bug. Always go through fmtDate.

const PLACEHOLDER = "—";

function _valid(d) {
  if (d === null || d === undefined || d === "") return null;
  const parsed = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(parsed.getTime())) return null;
  // Treat the unix epoch (or anything in 1970) as missing data, not a real date.
  if (parsed.getFullYear() <= 1970) return null;
  return parsed;
}

export function fmtDate(d) {
  const v = _valid(d);
  return v ? v.toLocaleDateString() : PLACEHOLDER;
}

export function fmtDateTime(d) {
  const v = _valid(d);
  return v ? v.toLocaleString() : PLACEHOLDER;
}

export function fmtShort(d) {
  const v = _valid(d);
  return v
    ? v.toLocaleDateString(undefined, { month: "short", day: "2-digit" })
    : PLACEHOLDER;
}
